<template>
  <div class="register-page">
    <!-- 动态背景 -->
    <div class="animated-background">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
      <div class="circle circle-5"></div>
    </div>

    <div class="register-container fade-in">
      <!-- 平台标题 -->
<!--      <div class="platform-title">-->
<!--        <div class="logo-icon">-->
<!--          <i class="el-icon-s-goods"></i>-->
<!--        </div>-->
<!--        <h1>供需发布平台</h1>-->
<!--        <p>开启您的商业之旅</p>-->
<!--      </div>-->

      <div class="register-box glass-effect">
        <div class="register-header">
          <h2>用户注册</h2>
          <p>Join Us Today</p>
        </div>

        <!-- 步骤指示器 -->
        <el-steps :active="currentStep" finish-status="success" align-center style="margin-bottom: 35px;">
          <el-step title="手机验证"></el-step>
          <el-step title="设置密码"></el-step>
          <el-step title="个人信息"></el-step>
          <el-step title="选择关注"></el-step>
        </el-steps>

        <!-- 步骤1：手机验证 -->
        <div v-if="currentStep === 0" class="step-content">
          <el-form :model="registerForm" ref="phoneForm" :rules="phoneRules">
            <el-form-item prop="phone">
              <el-input
                  v-model="registerForm.phone"
                  prefix-icon="el-icon-mobile-phone"
                  placeholder="请输入手机号">
              </el-input>
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha-row">
                <el-input
                    v-model="registerForm.captcha"
                    prefix-icon="el-icon-picture"
                    placeholder="请输入图片验证码"
                    maxlength="4"
                    class="captcha-input">
                </el-input>
                <img
                    :src="captchaUrl"
                    @click="refreshCaptcha"
                    class="captcha-image"
                    alt="验证码"
                    title="点击刷新验证码">
              </div>
            </el-form-item>
            <el-form-item prop="verificationCode">
              <el-input
                  v-model="registerForm.verificationCode"
                  prefix-icon="el-icon-message"
                  placeholder="请输入短信验证码">
                <el-button slot="append" @click="sendCode" :disabled="countdown > 0">
                  {{ countdown > 0 ? `${countdown}秒后重发` : '发送验证码' }}
                </el-button>
              </el-input>
            </el-form-item>
            <el-button type="primary" @click="nextStep" style="width: 100%;">下一步</el-button>
          </el-form>
        </div>

        <!-- 步骤2：设置密码 -->
        <div v-if="currentStep === 1" class="step-content">
          <el-form :model="registerForm" ref="passwordForm" :rules="passwordRules">
            <el-form-item prop="password">
              <el-input
                  type="password"
                  v-model="registerForm.password"
                  prefix-icon="el-icon-lock"
                  placeholder="请输入密码（6-20位）"
                  show-password>
              </el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input
                  type="password"
                  v-model="registerForm.confirmPassword"
                  prefix-icon="el-icon-lock"
                  placeholder="请再次输入密码"
                  show-password>
              </el-input>
            </el-form-item>
            <div style="display: flex; gap: 10px;">
              <el-button @click="prevStep" style="flex: 1;">上一步</el-button>
              <el-button type="primary" @click="nextStep" style="flex: 1;">下一步</el-button>
            </div>
          </el-form>
        </div>

        <!-- 步骤3：个人信息 -->
        <div v-if="currentStep === 2" class="step-content">
          <el-form :model="registerForm" ref="profileForm" :rules="profileRules" label-width="100px">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="registerForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="registerForm.companyName" placeholder="请输入公司名称"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="registerForm.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item label="部门" prop="department">
              <el-input v-model="registerForm.department" placeholder="请输入部门"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="registerForm.position" placeholder="请输入职位"></el-input>
            </el-form-item>
            <el-form-item label="国家/地区" prop="country">
              <el-select v-model="registerForm.country" placeholder="请选择国家/地区" style="width: 100%;">
                <el-option
                    v-for="country in countryList"
                    :key="country.value"
                    :label="country.label"
                    :value="country.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省/市/区" prop="province">
              <!-- 如果该国家有省市数据，显示级联选择器 -->
              <el-cascader
                  v-if="provinceOptions.length > 0"
                  v-model="selectedRegion"
                  :options="provinceOptions"
                  :props="cascaderProps"
                  @change="handleRegionChange"
                  placeholder="请选择省/市/区"
                  style="width: 100%;">
              </el-cascader>
              <!-- 否则显示输入框 -->
              <el-input
                  v-else
                  v-model="registerForm.province"
                  placeholder="请输入省/市/区">
              </el-input>
            </el-form-item>
            <el-form-item label="详细地址" prop="detailedAddress">
              <el-input v-model="registerForm.detailedAddress" placeholder="请输入详细地址"></el-input>
            </el-form-item>
            <el-form-item label="邮政编码">
              <el-input v-model="registerForm.postalCode" placeholder="请输入邮政编码"></el-input>
            </el-form-item>
            <div style="display: flex; gap: 10px;">
              <el-button @click="prevStep" style="flex: 1;">上一步</el-button>
              <el-button type="primary" @click="nextStep" style="flex: 1;">下一步</el-button>
            </div>
          </el-form>
        </div>

        <!-- 步骤4：选择关注的产品和领域 -->
        <div v-if="currentStep === 3" class="step-content">
          <h3 style="text-align: center; margin-bottom: 10px;">请选择您关注的行业</h3>
          <div style="text-align: center; margin-bottom: 20px; color: #909399; font-size: 14px;">
            <i class="el-icon-info"></i> 提示：请展开选择您感兴趣的具体行业
          </div>
          <el-tree
              ref="categoryTree"
              :data="categoryTree"
              show-checkbox
              node-key="id"
              :props="treeProps"
              @check="handleCategoryCheck"
              default-expand-all
              style="margin-bottom: 20px; max-height: 400px; overflow-y: auto; border: 1px solid #EBEEF5; padding: 15px; border-radius: 4px;">
          </el-tree>
          <el-alert
              v-if="selectedCategories.length === 0"
              title="请至少选择一个行业"
              type="warning"
              :closable="false">
          </el-alert>
          <div v-else style="margin: 15px 0;">
            <el-tag v-for="cat in selectedCategories.slice(0, 10)" :key="cat.id"
                    style="margin-right: 5px; margin-bottom: 5px;">
              {{ cat.name }}
            </el-tag>
            <span v-if="selectedCategories.length > 10" style="color: #909399; font-size: 14px;">
            等{{ selectedCategories.length }}项
          </span>
          </div>
          <div style="display: flex; gap: 10px; margin-top: 20px;">
            <el-button @click="prevStep" style="flex: 1;">上一步</el-button>
            <el-button type="primary" @click="nextStep" :disabled="selectedCategories.length === 0" style="flex: 1;">
              完成注册
            </el-button>
          </div>
        </div>


        <div class="login-link-wrapper">
          <span>已有账号？</span>
          <router-link to="/login" class="login-link">
            立即登录 <i class="el-icon-arrow-right"></i>
          </router-link>
        </div>
      </div>

      <!-- 页面底部 -->
<!--      <div class="page-footer">-->
<!--        <p>© 2025 供需发布平台 - 让商业更简单</p>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import {countryList, provinceOptions, countryRegionMap} from "@/utils/regionData";
import { getCaptchaUrl } from '@/config/api';

export default {
  name: "Register",
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'));
      } else if (value.length < 6 || value.length > 20) {
        callback(new Error('密码长度为6-20位'));
      } else {
        callback();
      }
    };

    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

    return {
      currentStep: 0,
      countdown: 0,
      captchaKey: '',
      captchaUrl: '',
      registerForm: {
        phone: '',
        captcha: '',
        verificationCode: '',
        password: '',
        confirmPassword: '',
        name: '',
        companyName: '',
        email: '',
        country: '中国',
        province: '',
        city: '',
        district: '',
        detailedAddress: '',
        postalCode: '',
        department: '',
        position: ''
      },
      phoneRules: {
        phone: [{validator: validatePhone, trigger: 'blur'}],
        captcha: [{required: true, message: '请输入图片验证码', trigger: 'blur'}],
        verificationCode: [{required: true, message: '请输入短信验证码', trigger: 'blur'}]
      },
      passwordRules: {
        password: [{validator: validatePassword, trigger: 'blur'}],
        confirmPassword: [{validator: validateConfirmPassword, trigger: 'blur'}]
      },
      profileRules: {
        name: [{required: true, message: '请输入姓名', trigger: 'blur'}],
        companyName: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'blur'},
          {type: 'email', message: '请输入正确的邮箱', trigger: 'blur'}
        ],
        country: [{required: true, message: '请选择国家/地区', trigger: 'change'}],
        province: [{required: true, message: '请选择省/市/区', trigger: 'change'}],
        detailedAddress: [{required: true, message: '请输入详细地址', trigger: 'change'}],
        position: [{required: true, message: '请输入职位', trigger: 'change'}],
        department: [{required: true, message: '请输入所在部门', trigger: 'change'}]
      },
      categoryTree: [],
      selectedCategories: [],
      treeProps: {
        children: 'children',
        label: 'name'
      },
      // 从外部导入国家和省市数据
      countryList: countryList,
      provinceOptions: provinceOptions,
      countryRegionMap: countryRegionMap,
      // 选中的地区
      selectedRegion: [],
      // 级联选择器配置
      cascaderProps: {
        value: 'value',
        label: 'label',
        children: 'children'
      }
    }
  },
  watch: {
    // 监听国家选择变化，动态更新省市数据
    'registerForm.country'(newCountry) {
      // 切换国家时清空已选省市区
      this.selectedRegion = [];
      this.registerForm.province = '';
      this.registerForm.city = '';
      this.registerForm.district = '';

      // 根据国家加载对应的省市数据
      if (this.countryRegionMap[newCountry]) {
        this.provinceOptions = this.countryRegionMap[newCountry];
      } else {
        // 如果该国家没有省市数据，使用空数组
        this.provinceOptions = [];
      }
    }
  },
  mounted() {
    this.refreshCaptcha();
    this.loadCategoryTree();
  },
  methods: {
    // 刷新验证码
    refreshCaptcha() {
      this.captchaKey = 'captcha_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      this.captchaUrl = getCaptchaUrl(this.captchaKey);
    },

    // 发送验证码
    sendCode() {
      // 先检查手机号和图片验证码是否填写
      if (!this.registerForm.phone) {
        this.$message.warning('请先填写手机号');
        return;
      }
      if (!this.registerForm.captcha) {
        this.$message.warning('请先填写图片验证码');
        return;
      }

      // 防止重复点击
      if (this.countdown > 0) {
        return;
      }

      // 验证手机号格式
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.registerForm.phone)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }

      // 先验证图片验证码
      request.post('/captcha/verify', null, {
        params: {
          key: this.captchaKey,
          code: this.registerForm.captcha
        }
      }).then(res => {
        if (res.code === '200') {
          // 图片验证码正确，发送短信验证码
          request.post('/user/send-code', null, {
            params: {
              phone: this.registerForm.phone,
              type: 'register'
            }
          }).then(res => {
            if (res.code === '200') {
              this.$message.success('验证码已发送');
              this.countdown = 60;
              this.startCountdown();
            } else {
              this.$message.error(res.msg || '发送失败');
              this.refreshCaptcha();
            }
          }).catch(error => {
            this.$message.error('发送失败，请稍后重试');
            this.refreshCaptcha();
          });
        } else {
          this.$message.error(res.msg || '图片验证码错误');
          this.refreshCaptcha();
          this.registerForm.captcha = '';
        }
      }).catch(error => {
        this.$message.error('验证码验证失败');
        this.refreshCaptcha();
        this.registerForm.captcha = '';
      });
    },

    // 倒计时
    startCountdown() {
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    // 下一步
    nextStep() {
      const formRefs = ['phoneForm', 'passwordForm', 'profileForm'];
      const currentFormRef = formRefs[this.currentStep];

      if (this.currentStep === 0) {
        // 步骤1：验证手机号和验证码
        this.$refs[currentFormRef].validate((valid) => {
          if (valid) {
            // 验证验证码
            request.post('/user/verify-code', null, {
              params: {
                phone: this.registerForm.phone,
                code: this.registerForm.verificationCode,
                type: 'register'
              }
            }).then(res => {
              if (res.code === '200') {
                // 检查手机号是否已注册
                request.get('/user/check-phone', {
                  params: {phone: this.registerForm.phone}
                }).then(res => {
                  if (res.code === '200' && res.data && res.data.exists) {
                    this.$message.error('该手机号已注册');
                  } else {
                    this.currentStep++;
                  }
                }).catch(error => {
                  // console.error('检查手机号失败:', error);
                  // 即使检查失败也允许继续（可选）
                  this.currentStep++;
                });
              } else {
                this.$message.error(res.msg || '验证码错误');
              }
            });
          }
        });
      } else if (this.currentStep === 1) {
        // 步骤2：密码验证
        this.$refs[currentFormRef].validate((valid) => {
          if (valid) {
            this.currentStep++;
          }
        });
      } else if (this.currentStep === 2) {
        // 步骤3：个人信息验证
        this.$refs[currentFormRef].validate((valid) => {
          if (valid) {
            // 如果使用级联选择器，检查是否已选择
            if (this.provinceOptions.length > 0 && (!this.selectedRegion || this.selectedRegion.length === 0)) {
              this.$message.warning('请选择省/市/区');
              return;
            }
            // 如果使用输入框，检查是否已填写
            if (this.provinceOptions.length === 0 && !this.registerForm.province) {
              this.$message.warning('请输入省/市/区');
              return;
            }
            this.currentStep++;
          }
        });
      } else if (this.currentStep === 3) {
        // 步骤4：检查是否选择了关注，直接完成注册
        if (this.selectedCategories.length > 0) {
          this.completeRegistration();
        } else {
          this.$message.warning('请至少选择一个产品/领域或行业');
        }
      }
    },

    // 上一步
    prevStep() {
      this.currentStep--;
    },

    // 完成注册
    completeRegistration() {
      // 构建用户关注列表
      const interests = [];
      const checkedNodes = this.$refs.categoryTree.getCheckedNodes();

      // console.log('选中的节点：', checkedNodes);

      // 遍历选中的节点
      checkedNodes.forEach(node => {
        if (node.children && node.children.length > 0) {
          // 这是产品/领域节点（有子节点）
          // 检查是否有选中的子节点（行业）
          const selectedIndustries = node.children.filter(child =>
              checkedNodes.some(n => n.id === child.id)
          );

          if (selectedIndustries.length > 0) {
            // 如果选中了行业，为每个行业创建关注记录
            selectedIndustries.forEach(industry => {
              interests.push({
                categoryId: node.id,
                industryId: industry.id
              });
            });
          } else {
            // 如果只选中了产品/领域，没有选中行业
            interests.push({
              categoryId: node.id,
              industryId: null
            });
          }
        } else if (node.pid && node.pid !== 0) {
          // 这是行业节点（有父节点）
          // 只有在没有处理过的情况下才添加
          const alreadyAdded = interests.some(i =>
              i.categoryId === node.pid && i.industryId === node.id
          );
          if (!alreadyAdded) {
            interests.push({
              categoryId: node.pid,
              industryId: node.id
            });
          }
        }
      });

      // 去重
      const uniqueInterests = [];
      const seen = new Set();
      interests.forEach(interest => {
        const key = `${interest.categoryId}-${interest.industryId}`;
        if (!seen.has(key)) {
          seen.add(key);
          uniqueInterests.push(interest);
        }
      });

      // console.log('处理后的关注数据：', uniqueInterests);

      // 提交注册信息
      const registerData = {
        ...this.registerForm,
        interests: uniqueInterests
      };

      request.post('/user/complete-profile', registerData).then(res => {
        if (res.code === '200') {
          this.$message.success('注册成功！即将跳转到登录页面');
          setTimeout(() => {
            this.$router.push('/login');
          }, 2000);
        } else {
          this.$message.error(res.msg || '注册失败');
        }
      }).catch(error => {
        this.$message.error('注册失败，请重试');
        // console.error(error);
      });
    },

    // 加载分类树
    loadCategoryTree() {
      request.get('/category/tree').then(res => {
        if (res.code === '200') {
          this.categoryTree = res.data;
        }
      });
    },

    // 处理分类选择
    handleCategoryCheck() {
      const checkedNodes = this.$refs.categoryTree.getCheckedNodes();
      this.selectedCategories = checkedNodes;
    },

    // 处理省市区选择
    handleRegionChange(value) {
      if (value && value.length >= 1) {
        // 省份
        this.registerForm.province = value[0] || '';
        // 城市
        this.registerForm.city = value[1] || '';
        // 区县
        this.registerForm.district = value[2] || '';

        // console.log('选择的地区：', {
        //     province: this.registerForm.province,
        //         city
        //   :
        //     this.registerForm.city,
        //         district
        //   :
        //     this.registerForm.district
        //   }
        // );
      }
    }
  }
}

</script>

<style scoped>
.register-page {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 40px 50px 40px 20px;
  overflow: hidden;
  background-image: url('@/assets/svg/供需.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

/* 动态背景动画 */
.animated-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 20s infinite ease-in-out;
}

.circle-1 {
  width: 300px;
  height: 300px;
  top: 10%;
  left: 10%;
  animation-duration: 18s;
}

.circle-2 {
  width: 200px;
  height: 200px;
  top: 60%;
  left: 70%;
  animation-duration: 22s;
  animation-delay: -5s;
}

.circle-3 {
  width: 150px;
  height: 150px;
  top: 30%;
  left: 80%;
  animation-duration: 25s;
  animation-delay: -10s;
}

.circle-4 {
  width: 250px;
  height: 250px;
  top: 70%;
  left: 20%;
  animation-duration: 20s;
  animation-delay: -15s;
}

.circle-5 {
  width: 180px;
  height: 180px;
  top: 40%;
  left: 40%;
  animation-duration: 23s;
  animation-delay: -8s;
}

@keyframes float {
  0%, 100% {
    transform: translate(0, 0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translate(50px, 50px) scale(1.1);
    opacity: 0.5;
  }
}

/* 注册容器 */
.register-container {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 585px;
  transform-origin: right center;
}

/* 平台标题 */
.platform-title {
  text-align: center;
  margin-bottom: 30px;
  color: white;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.logo-icon {
  font-size: 60px;
  margin-bottom: 15px;
  animation: pulse 2s infinite;
}

.platform-title h1 {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 10px 0;
  letter-spacing: 2px;
}

.platform-title p {
  font-size: 16px;
  opacity: 0.9;
  margin: 0;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

/* 注册卡片 */
.register-box {
  background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 45px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.5);
}

.register-header {
  text-align: center;
  margin-bottom: 35px;
}

.register-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: 600;
}

.register-header p {
  color: #999;
  font-size: 14px;
  margin: 0;
}

.step-content {
  margin-top: 25px;
  padding: 20px;
  background: rgba(250, 250, 250, 0.5);
  border-radius: 12px;
  min-height: 350px;
}

/* 验证码行 */
.captcha-row {
  display: flex;
  gap: 12px;
  align-items: center;
}

.captcha-input {
  flex: 1;
}

.captcha-image {
  width: 120px;
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid #e8e8e8;
  transition: all 0.3s;
  flex-shrink: 0;
}

.captcha-image:hover {
  border-color: var(--primary-color);
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.success-icon {
  text-align: center;
  margin: 20px 0;
}

.el-form-item {
  margin-bottom: 20px;
}

/* 表单输入框 */
.register-box >>> .el-input__inner {
  border-radius: 10px;
  height: 45px;
  line-height: 45px;
  border: 2px solid #e8e8e8;
  transition: all 0.3s;
}

.register-box >>> .el-input__inner:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.register-box >>> .el-input__icon {
  line-height: 45px;
}

/* 按钮样式 */
.register-box >>> .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 10px;
  padding: 13px 20px;
  font-weight: 600;
  transition: all 0.3s;
}

.register-box >>> .el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.register-box >>> .el-button {
  border-radius: 10px;
  padding: 13px 20px;
  font-weight: 500;
}

/* 级联选择器 */
.register-box >>> .el-cascader {
  width: 100%;
}

/* 树形控件 */
.register-box >>> .el-tree {
  border-radius: 10px;
}

/* 步骤条美化 */
.register-box >>> .el-steps {
  padding: 0 20px;
}

.register-box >>> .el-step__icon {
  width: 36px;
  height: 36px;
  font-size: 16px;
}

.register-box >>> .el-step__title {
  font-size: 14px;
  font-weight: 500;
}

.register-box >>> .el-step__head.is-finish .el-step__icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: transparent;
}

.register-box >>> .el-step__head.is-process .el-step__icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: transparent;
}

/* 登录链接 */
.login-link-wrapper {
  text-align: center;
  margin-top: 25px;
  padding-top: 20px;
  border-top: 1px solid #e8e8e8;
  font-size: 14px;
  color: #666;
}

.login-link {
  color: var(--primary-color);
  font-weight: 600;
  text-decoration: none;
  margin-left: 8px;
  transition: all 0.3s;
}

.login-link:hover {
  color: var(--primary-light);
  transform: translateX(3px);
  display: inline-block;
}

/* 页面底部 */
.page-footer {
  text-align: center;
  margin-top: 25px;
  color: white;
  font-size: 13px;
  opacity: 0.8;
}

/* 渐入动画 */
.fade-in {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .register-page {
    justify-content: center;
    padding: 40px 20px;
  }

  .register-container {
    padding: 15px;
    transform: scale(1);
    transform-origin: center center;
    max-width: 100%;
  }

  .platform-title h1 {
    font-size: 28px;
  }

  .logo-icon {
    font-size: 50px;
  }

  .register-box {
    padding: 30px 20px;
  }

  .step-content {
    padding: 15px;
    min-height: 300px;
  }

  .register-box >>> .el-steps {
    padding: 0 10px;
  }

  .register-box >>> .el-step__title {
    font-size: 12px;
  }
}
</style>
